export default "__VITE_ASSET__CqeQOJ0t__"